<!--~
  ~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
  ~ to an End-User License Agreement included in a separate file named EULA.txt
  ~ that is distributed with this file.
  -->
<mat-select [placeholder]="placeholder" [disabled]="disabled" [(value)]="value">
    <mat-option [value]="undefined">-- Select --</mat-option>
    <mat-option *ngFor="let opt of options" [value]="opt.value">{{opt.text}}</mat-option>
</mat-select>
